
export default class WaitingState {

	constructor (scene) {

		this.scene = scene;
		this.name = "waiting";
	}
}